import { copyToArray2j022khrow2yi as copyToArray } from '../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  CancelHandler3ic7xysezxbm5 as CancelHandler,
  CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl,
} from './CancellableContinuationImpl.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { JobNode2tu3g3s3xsko1 as JobNode } from './JobSupport.mjs';
import {
  atomic$ref$130aurmcwdfdf1 as atomic$ref$1,
  atomic$int$11d5swdyn6j0pu as atomic$int$1,
} from '../../../kotlinx-atomicfu/kotlinx/atomicfu/AtomicFU.mjs';
import { throwUninitializedPropertyAccessException14fok093f3k3t as throwUninitializedPropertyAccessException } from '../../../kotlin-kotlin-stdlib/kotlin/internal/ThrowHelpers.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  Companion_instancejy2056q2ma5w as Companion_instance,
  _Result___init__impl__xyqfz832zdzqrocazzs as _Result___init__impl__xyqfz8,
} from '../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { invokeOnCompletion3npqdfp2wzhn6 as invokeOnCompletion } from './Job.mjs';
import { invokeOnCancellationb68niwbjdmgy as invokeOnCancellation } from './CancellableContinuation.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *awaitAll(_this__u8e3s4, $completion) {
  var tmp;
  if (_this__u8e3s4.isEmpty_y1axqb_k$()) {
    tmp = emptyList();
  } else {
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$0 = copyToArray(_this__u8e3s4);
    tmp = yield* (new (AwaitAll())(tmp$ret$0)).await_63ppyd_k$($completion);
  }
  return tmp;
}
var DisposeHandlersOnCancelClass;
function DisposeHandlersOnCancel() {
  if (DisposeHandlersOnCancelClass === VOID) {
    class $ {
      constructor($outer, nodes) {
        this.$this_1 = $outer;
        this.nodes_1 = nodes;
      }
      disposeAll_hpz7bi_k$() {
        // Inline function 'kotlin.collections.forEach' call
        var indexedObject = this.nodes_1;
        var inductionVariable = 0;
        var last = indexedObject.length;
        while (inductionVariable < last) {
          var element = indexedObject[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          element.get_handle_e5p7ht_k$().dispose_3nnxhr_k$();
        }
      }
      invoke_py2q9a_k$(cause) {
        this.disposeAll_hpz7bi_k$();
      }
      toString() {
        return 'DisposeHandlersOnCancel[' + toString(this.nodes_1) + ']';
      }
    }
    initMetadataForClass($, 'DisposeHandlersOnCancel', VOID, VOID, [CancelHandler()]);
    DisposeHandlersOnCancelClass = $;
  }
  return DisposeHandlersOnCancelClass;
}
var AwaitAllNodeClass;
function AwaitAllNode() {
  if (AwaitAllNodeClass === VOID) {
    class $ extends JobNode() {
      constructor($outer, continuation, $box) {
        if ($box === VOID)
          $box = {};
        $box.$this_1 = $outer;
        super($box);
        this.continuation_1 = continuation;
        this._disposer_1 = atomic$ref$1(null);
      }
      get_handle_e5p7ht_k$() {
        var tmp = this.handle_1;
        if (!(tmp == null))
          return tmp;
        else {
          throwUninitializedPropertyAccessException('handle');
        }
      }
      set_disposer_qhnkga_k$(value) {
        this._disposer_1.kotlinx$atomicfu$value = value;
      }
      get_disposer_r356h0_k$() {
        return this._disposer_1.kotlinx$atomicfu$value;
      }
      get_onCancelling_k07uns_k$() {
        return false;
      }
      invoke_py2q9a_k$(cause) {
        if (!(cause == null)) {
          var token = this.continuation_1.tryResumeWithException_4drsj6_k$(cause);
          if (!(token == null)) {
            this.continuation_1.completeResume_fabtk_k$(token);
            var tmp0_safe_receiver = this.get_disposer_r356h0_k$();
            if (tmp0_safe_receiver == null)
              null;
            else {
              tmp0_safe_receiver.disposeAll_hpz7bi_k$();
            }
          }
        } else if (this.$this_1.notCompletedCount_1.atomicfu$decrementAndGet() === 0) {
          var tmp0 = this.continuation_1;
          // Inline function 'kotlin.collections.map' call
          var this_0 = this.$this_1.deferreds_1;
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(this_0.length);
          var inductionVariable = 0;
          var last = this_0.length;
          while (inductionVariable < last) {
            var item = this_0[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            var tmp$ret$2 = item.getCompleted_nczk2z_k$();
            destination.add_utx5q5_k$(tmp$ret$2);
          }
          // Inline function 'kotlin.coroutines.resume' call
          // Inline function 'kotlin.Companion.success' call
          var tmp$ret$4 = _Result___init__impl__xyqfz8(destination);
          tmp0.resumeWith_rk9gbt_k$(tmp$ret$4);
        }
      }
    }
    initMetadataForClass($, 'AwaitAllNode');
    AwaitAllNodeClass = $;
  }
  return AwaitAllNodeClass;
}
var AwaitAllClass;
function AwaitAll() {
  if (AwaitAllClass === VOID) {
    class $ {
      constructor(deferreds) {
        this.deferreds_1 = deferreds;
        this.notCompletedCount_1 = atomic$int$1(this.deferreds_1.length);
      }
      *await_63ppyd_k$($completion) {
        // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
        // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
        return yield () => {
          var uCont = $completion;
          var cancellable = new (CancellableContinuationImpl())(intercepted(uCont), 1);
          cancellable.initCancellability_shqc60_k$();
          var tmp = 0;
          var tmp_0 = this.deferreds_1.length;
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_1 = Array(tmp_0);
          while (tmp < tmp_0) {
            var tmp_2 = tmp;
            var deferred = this.deferreds_1[tmp_2];
            deferred.start_1tchgi_k$();
            // Inline function 'kotlin.apply' call
            var this_0 = new (AwaitAllNode())(this, cancellable);
            this_0.handle_1 = invokeOnCompletion(deferred, VOID, this_0);
            tmp_1[tmp_2] = this_0;
            tmp = tmp + 1 | 0;
          }
          var nodes = tmp_1;
          var disposer = new (DisposeHandlersOnCancel())(this, nodes);
          // Inline function 'kotlin.collections.forEach' call
          var inductionVariable = 0;
          var last = nodes.length;
          while (inductionVariable < last) {
            var element = nodes[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            element.set_disposer_qhnkga_k$(disposer);
          }
          if (cancellable.get_isCompleted_a6j6c8_k$()) {
            disposer.disposeAll_hpz7bi_k$();
          } else {
            invokeOnCancellation(cancellable, disposer);
          }
          return cancellable.getResult_fck196_k$();
        };
      }
    }
    initMetadataForClass($, 'AwaitAll', VOID, VOID, VOID, [0]);
    AwaitAllClass = $;
  }
  return AwaitAllClass;
}
//region block: exports
export {
  awaitAll as awaitAllfig2t8ybkmg8,
};
//endregion

//# sourceMappingURL=Await.mjs.map
